import type { SliceComponentProps } from "@prismicio/react";
import CategoryFaq from "./variations/CategoryFaq";
import DefaultFaq from "./variations/DefaultFaq";
import type { FaqSliceSlice } from "prismicio-types";

const FaqSection = ({ slice }: SliceComponentProps<FaqSliceSlice>) => {
  switch (slice.variation) {
    case "default": {
      return <DefaultFaq slice={slice} />;
    }
    case "categoryFaq": {
      return <CategoryFaq slice={slice} />;
    }
  }
};

export default FaqSection;
